import {
  Tag,
  UtensilsCrossed,
  Home,
  Plane,
  Briefcase,
  GraduationCap,
  Handshake,
  Car,
  Wrench,
  Fuel,
  Phone,
  Shirt,
  MoreHorizontal,
  type LucideIcon,
} from "lucide-react";
import { CategoryItemType } from "../models/category";

export const CATEGORY_ICONS: Record<CategoryItemType, LucideIcon> = {
  STANDARD: Tag,
  MEAL: UtensilsCrossed,
  HOUSING: Home,
  TRAVEL: Plane,
  OFFICE: Briefcase,
  TRAINING: GraduationCap,
  PROVIDER: Handshake,
  VEHICLE: Car,
  EQUIPMENT: Wrench,
  FUEL: Fuel,
  PHONE: Phone,
  PRESSING: Shirt,
  OTHER: MoreHorizontal,
};

export function getCategoryIcon(itemType: CategoryItemType): LucideIcon {
  return CATEGORY_ICONS[itemType] ?? Tag;
}

interface CategoryIconProps {
  itemType: CategoryItemType;
  size?: number;
  className?: string;
}

export function CategoryIcon({
  itemType,
  size = 16,
  className,
}: CategoryIconProps) {
  const Icon = getCategoryIcon(itemType);
  return <Icon size={size} className={className} />;
}
